import { render, staticRenderFns } from "./LeadsCosts.vue?vue&type=template&id=4cf8e468&scoped=true&"
import script from "./LeadsCosts.vue?vue&type=script&lang=js&"
export * from "./LeadsCosts.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCosts.vue?vue&type=style&index=0&id=4cf8e468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8e468",
  null
  
)

export default component.exports